import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { useWallet } from "@solana/wallet-adapter-react";
import { useState, useEffect } from 'react';
import { FaTelegram } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

const CustomWalletButton = () => {
  const { connected, publicKey } = useWallet();
  const shortenAddress = (address) => {
    if (!address) return '';
    return `${address.toString().slice(0, 4)}...${address.toString().slice(-4)}`;
  };
  return (
    <WalletMultiButton className="bg-black text-white border border-[#22C8BF] truncate hover:bg-opacity-10 hover:text-[#22C8BF]">
      {!connected ? 'Connect Wallet' : shortenAddress(publicKey)}
    </WalletMultiButton>
  );
};

const TopNavbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const socialLinks = [
    {
      name: 'Telegram',
      url: 'https://t.me/ciphegis2050',
      icon: FaTelegram
    },
    {
      name: 'Twitter',
      url: 'https://x.com/ciphegis',
      icon: FaXTwitter
    }
  ];
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 1000);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div
      className={`fixed top-0 z-50 w-full h-[100px] px-10 transition-all duration-300 ${isScrolled ? 'bg-black' : 'bg-transparent'
        }`}
      id="Navbar"
    >
      <div className="flex justify-between items-center w-full px-4 relative container mx-auto h-full">
        <div className="flex xl:gap-4 gap-1">
          <div className="flex w-20 h-20 items-center gap-3 animate-cyber-glow">
            <img
              src="/static/images/Logo.svg"
              className="w-16 h-16"
              alt="taptool"
            />
          </div>
        </div>
        <div className="flex items-center gap-8">
          <CustomWalletButton />
          <div className="flex items-center justify-between 2xl:gap-10 gap-4">
            <p
              onClick={() => scrollToSection('Web3')}
              className="text-white cursor-pointer hover:text-[#22C8BF] transition-colors duration-300"
            >
              Web3
            </p>
            <p
              onClick={() => scrollToSection('Presale')}
              className="text-white cursor-pointer hover:text-[#22C8BF] transition-colors duration-300"
            >
              Pre-Sale
            </p>
            <p
              onClick={() => scrollToSection('Live')}
              className="text-white cursor-pointer hover:text-[#22C8BF] transition-colors duration-300"
            >
              Live!
            </p>
            <p
              onClick={() => scrollToSection('Ciphegis')}
              className="text-white cursor-pointer hover:text-[#22C8BF] transition-colors duration-300"
            >
              Ciphegis
            </p>
            <p
              onClick={() => scrollToSection('Supply')}
              className="text-white cursor-pointer hover:text-[#22C8BF] transition-colors duration-300"
            >
              Supply
            </p>
            <p
              onClick={() => scrollToSection('Staking')}
              className="text-white cursor-pointer hover:text-[#22C8BF] transition-colors duration-300"
            >
              Staking
            </p>
            <p
              onClick={() => scrollToSection('Roadmap')}
              className="text-white cursor-pointer hover:text-[#22C8BF] transition-colors duration-300"
            >
              Road Map
            </p>
            <a
              href="https://tally.so/r/nG7LrL"
              target="_blank"
              className="text-white cursor-pointer hover:text-[#22C8BF] transition-colors duration-300" rel="noreferrer"
            >
              Sign Up
            </a>
          </div>
          <div className="flex items-center gap-2 -ml-4">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="p-1 hover:bg-[#22C8BF]/10 rounded-lg transition-all duration-300"
              >
                <social.icon
                  className="w-6 h-6 text-white hover:text-[#22C8BF] hover:scale-110 transition-all duration-300"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopNavbar;
